export const CUSTOMER_EMAIL_LANGUAGE_SOURCES = [
  'customerPreferredLocale',
  'tenantDefaultLocale',
  'unknown',
] as const;

export type CustomerEmailLanguageSource = (typeof CUSTOMER_EMAIL_LANGUAGE_SOURCES)[number];
